import React from "react";
import { ReactComponent as DigestDocumentIcon } from "uikit/assets/icons/digestDocumentIcon.svg";
import { Card } from "uikit/components";
import styles from "./DigestDocument.module.styl";
import PropTypes from "prop-types";

export default function DigestDocument({ showAsButton, link, title, dataTestName }) {
    return (
        <>
            {!showAsButton ? (
                <a
                    className={styles.link}
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    data-test-name={dataTestName}
                >
                    {<DigestDocumentIcon className={styles.icon} />}
                    <span className={styles.linkText}>{title}</span>
                </a>
            ) : (
                <Card borderRadius={"giant"} padding={"none"} className={styles.button}>
                    <a className={styles.link} href={link} target="_blank" rel="noreferrer">
                        {<DigestDocumentIcon className={styles.icon} />}
                        <span className={styles.linkText}>{title}</span>
                    </a>
                </Card>
            )}
        </>
    );
}

DigestDocument.propTypes = {
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    showAsButton: PropTypes.bool.isRequired,
    dataTestName: PropTypes.string.isRequired,
};
